// extracted by mini-css-extract-plugin
export const form = "j_bc";
export const form_title = "j_bd";
export const form_rowfields = "j_bf";
export const form_textarea = "j_bg";
export const form_btn = "j_bh";